import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  RoomId: "",
  RoomName: "",
  RoomType: null,
  RoomCreatedAt: null,
  RoomCreator: null,
  RoomUsers: [],
  RoomCustomers: [],
  RoomIsFavorite: false,
};
const Reducer = createSlice({
  name: "Chat",
  initialState,
  reducers: {
    SetChatData(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    ResetChatData(_, action) {
      return {
        ...initialState,
        ...action.payload,
      };
    },
  },
});

export default Reducer.reducer;
export const { SetChatData, ResetChatData } = Reducer.actions;
